import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';

import { hideStickyMenus, showParticipantStickyMenu } from '../../../store/formsState';
import DarTableManagement from '../../home/dar/DarTableManagement';
import ParticipantStickyMenu from '../../navigation/participant/ParticipantStickyMenu';
import AccordionHeader from '../../ui/accordion/AccordionHeader';
import AccordionIcon from '../../ui/accordion/AccordionIcon';

import ClaimsForecastingTableManagement from './claimsForecasting/ClaimsForecastingTableManagement';
import HmrcData from './hmrcData/HmrcData';

import classes from '../../../app.module.css';
import app from '../../../app.module.css';

const ParticipantValidation = () => {
    //  HOOKS
    const dispatch = useDispatch();

    const [expanded, setExpanded] = useState('');

    const onPanelChange = (panel) => setExpanded(expanded === panel ? '' : panel);

    //  USE EFFECTS
    useEffect(() => {
        dispatch(showParticipantStickyMenu());
        return () => {
            dispatch(hideStickyMenus());
        };
    }, []);

    return (
        <div className={classes.withSideBar}>
            <div className={classes.pageContainer} data-testid="form_start">
                <h1 className={classes.mainHeading}>Participant Validations</h1>
                <div className={app.accordionDivider}>
                    <Accordion
                        expanded={expanded === 'claims'}
                        slotProps={{ transition: { mountOnEnter: true } }}
                        onChange={() => onPanelChange('claims')}>
                        <AccordionSummary
                            expandIcon={<AccordionIcon />}
                            aria-controls="claims-content"
                            id="claims-header">
                            <AccordionHeader>Claims</AccordionHeader>
                        </AccordionSummary>
                        <AccordionDetails>
                            {expanded === 'claims' && (
                                <>
                                    <ClaimsForecastingTableManagement />
                                    <HmrcData />
                                </>
                            )}
                        </AccordionDetails>
                    </Accordion>
                </div>
                <div className={app.accordionDivider}>
                    <Accordion
                        expanded={expanded === 'dataAmendmentRequests'}
                        slotProps={{ transition: { mountOnEnter: true } }}
                        onChange={() => onPanelChange('dataAmendmentRequests')}>
                        <AccordionSummary
                            expandIcon={<AccordionIcon />}
                            aria-controls="dar-content"
                            id="dar-header">
                            <AccordionHeader>Data Amendment Requests</AccordionHeader>
                        </AccordionSummary>
                        <AccordionDetails>
                            {expanded === 'dataAmendmentRequests' && <DarTableManagement />}
                        </AccordionDetails>
                    </Accordion>
                </div>
            </div>
            <div className={classes.sideBar}>
                <ParticipantStickyMenu />
            </div>
        </div>
    );
};

export default ParticipantValidation;
